import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { HelperNavigationModule } from '@core/components/helpers/navigation/navigation.module';
import { HelperIconsModule } from '@core/components/helpers/icons/icons.module';
import { FilesListModule } from '@core/components/files/lists/lists.module';
import { StoragePreviewModule } from '@core/components/storage-preview/storage-preview.module';
import { CorePdfViwerModule } from '@core/components/pdf/pdf.module';

import { SignedFilesListComponent } from './list/signed-files-list.component';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        HelperNavigationModule,
        HelperIconsModule,
        FilesListModule,
        StoragePreviewModule,
        CorePdfViwerModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        SignedFilesListComponent,
    ],
    exports: [
        SignedFilesListComponent,
    ],
})
export class SignedFilesModule { }
